import React from 'react';
import Pane from "../../../Components/Pane";
import SecondaryTitle from "../../../Components/SecondaryTitle";
import Loader from "../../../Components/Loader";
import {JOURNEYS} from "../../../constants";

const LoadingPage = (props) => {
    const {
        journey = JOURNEYS.AGENT
    } = props;

    return (
        <Pane>
            <SecondaryTitle style={{textAlign: 'center'}}>Loading</SecondaryTitle>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Loader />
            </div>
        </Pane>
    );
}

export default LoadingPage;
